import { render } from "./BetRecord.vue?vue&type=template&id=24d47d09&scoped=true"
import script from "./BetRecord.vue?vue&type=script&lang=js"
export * from "./BetRecord.vue?vue&type=script&lang=js"

import "./BetRecord.vue?vue&type=style&index=0&id=24d47d09&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d47d09"]])

export default __exports__